import { makeStyles } from '@material-ui/core/styles'
import { useSelector } from 'react-redux'

const KycStatus = () => {
  const classes = useStyles()
  const guestUserDetails = useSelector((state) => state?.buyPolicyReducer)

  return (
    <>
      <div className={classes.mainContainer}>
        <iframe
          src={guestUserDetails?.kycLink}
          className={classes.iframeContainer}
        />
      </div>
    </>
  )
}

export default KycStatus

const useStyles = makeStyles({
  mainContainer: {
    width: 'calc(100vw)',
    height: 'calc(98vh)',
  },
  iframeContainer: {
    width: '100%',
    height: '100%',
    border: '0',
  },
})
